export const deepCloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
export const serialize = (obj) => {
    const str = [];
    for (const p in obj)
        if (obj[p]) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    return str.join('&');
};
//# sourceMappingURL=objects.js.map